/*! Version: b91cd8f9 */
webpackJsonp([3],{

/***/ 1:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Defer until launch
(0, _jquery2.default)(function () {
  (0, _jquery2.default)('.c-section-nav__link--top').click(function () {
    (0, _jquery2.default)('html, body').animate({ scrollTop: 0 }, 'slow');
  });
}); // Content page specific styles

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trans = trans;

var _translations = __webpack_require__(5);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* globals console window */

// Translation utility function

// Initalize translations. Find the table, and warn if empty
if (Object.keys(_translations2.default).length !== 0) {
  audit();
} else {}

/**
 * Translates a single string based on a global context translation table.
 * @param {string} sourceString - The string to be translated
 * @returns {string}
 */
function trans(sourceString) {
  if (_translations2.default.hasOwnProperty(sourceString)) {
    // If a translation exists, just return it
    return _translations2.default[sourceString];
  } else {

    // Find a similar string except with different case
    for (var key in _translations2.default) {
      if (sourceString.toLowerCase() === key.toLowerCase() && window.locale !== "en_US") {}
    }

    // Return original string untouched (on failure)

    // If no translation exists, let the user know
    return sourceString;
  }
}

/**
 * Performs an audit of the translation table, checking that all translations
 * are okay and any other audits which could help development
 */
function audit() {
  for (var key in _translations2.default) {
    if (key === _translations2.default[key] && window.locale !== "en") {}
  }
}

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compactHeaderCheck = compactHeaderCheck;

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _highContrast = __webpack_require__(35);

var _navigationPanel = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* A string containing a selector that includes the entire tooltip and its
* related elemernts (wrapper, contents of wrapper and button).
* @const
*/
var selectorAccessibilityTooltipContents = [".c-header-accessibility-tooltip *", ".c-header__accessibility-tooltip-button", ".c-header-accessibility-tooltip"].join(", ");

// Declare pre-stored DOM elements.
//
// While the elements aren't available until the DOM is ready (so they can't be
// selected here), they must be declared here in order to bring them into the
// global namespace of this file, as otherwise they would not be available to
// the rest of the functions which rely on them.

/* global window console document */

var elHighContrastToggleButton = void 0;
var elAccessibilityTooltipToggle = void 0;
var elAccessibilityTooltipWrapper = void 0;
var elHamburgerToggleButton = void 0;
var elNavigationMenuPointer = void 0;
var elCompactHeader = void 0;
var elCompactHeaderTopButton = void 0;
var elPageName = void 0;

var modifierAccessibilityTooltipOpen = "c-header-accessibility-tooltip--open";
var modifierNagivationMenuPointerHidden = "c-header__navigation-menu-pointer--hidden";

var headerHeight = void 0;

//onload
(0, _jquery2.default)(function () {
  // Pre-store selectors as DOM elements
  //
  // They were declared before without value, and now a value must be assigned
  // to each of them.
  elHighContrastToggleButton = (0, _jquery2.default)(".c-header-accessibility-tooltip__hc-toggle");
  elAccessibilityTooltipToggle = (0, _jquery2.default)(".c-header__accessibility-tooltip-button");
  elAccessibilityTooltipWrapper = (0, _jquery2.default)(".c-header-accessibility-tooltip");
  elHamburgerToggleButton = (0, _jquery2.default)(".c-header__hamburger");
  elPageName = (0, _jquery2.default)(".c-header-compact__page-name");
  elNavigationMenuPointer = (0, _jquery2.default)(".c-header__navigation-menu-pointer");
  elCompactHeader = (0, _jquery2.default)(".c-header-compact");
  elCompactHeaderTopButton = (0, _jquery2.default)(".c-header-compact__top-button");
  setupDesktopNavPointer();
  setupHamburger();

  // Check if high contrast mode needs to be toggled on
  (0, _highContrast.highContrastCheck)();

  // Bind the high contrast tooltip
  elHighContrastToggleButton.on("click", _highContrast.highContrastToggle);

  bindAccessibilityTooltip();
  setupCompactHeader();
});

/**
 * Bind the accessibility tooltip to the DOM
 *
 * @returns {undefined}
 */
function bindAccessibilityTooltip() {
  elAccessibilityTooltipToggle.on("click keypress", function (event) {
    var accessibilityIsOpen = elAccessibilityTooltipWrapper.hasClass(modifierAccessibilityTooltipOpen);

    if (accessibilityIsOpen) {
      closeAccessibilityTooltip();
    } else {
      openAccessibilityTooltip();
    }

    // Finally, prevent the default action.
    event.preventDefault();
  });
}

/**
 * Open the accessibility tooltip. This also binds all required attributes,
 * adds the required class and such.
 *
 * @returns {undefined}
 */
function openAccessibilityTooltip() {
  // Set the tooltip wrapper to have the open class
  elAccessibilityTooltipWrapper.addClass(modifierAccessibilityTooltipOpen)
  // Set the wrapper's hidden to false
  .attr("aria-hidden", "false")
  // Set the buttons' tabindex to 0 to make them tabbable
  .find("[role=switch], a").attr("tabindex", 0);

  // Set the panel to be aria-expanded
  elAccessibilityTooltipToggle.attr("aria-expanded", "true");

  // Bind event to the rest of the DOM.

  // The event is namespaced (.accessibility). The reason for this is that it
  // will be possible to later remove this event handler when it's run its
  // course (i.e. when the a11y tooltip closes).
  (0, _jquery2.default)(document).on("click.accessibility keypress.accessibility", function (event) {
    if (event.target.matches(selectorAccessibilityTooltipContents)) {} else {
      closeAccessibilityTooltip();
    }
  });
}

/**
 * Close the accessibility tooltip. This also binds all required attributes,
 * removes the required class and such.
 *
 * @returns {undefined}
 */
function closeAccessibilityTooltip() {
  // Remove the tooltip's open class
  elAccessibilityTooltipWrapper.removeClass(modifierAccessibilityTooltipOpen)
  // Set the tooltip to be aria-hidden
  .attr("aria-hidden", "true")
  // Set the buttons to be untabbable again
  .find("[role=switch], a").attr("tabindex", -1);

  // Set button to be collapsed
  elAccessibilityTooltipToggle.attr("aria-expanded", "false");

  (0, _jquery2.default)(document).off("click.accessibility keypress.accessibility");
}

//sets the hamburger to open the side nav panel
function setupHamburger() {
  // Open the navigation panel when the hamburger is clicked.
  elHamburgerToggleButton.on("click", function () {
    openNavpanel();
  });

  elPageName.on("click", function () {
    openNavpanel();
  });
}

//sets up the arrow in the header navigation panel on desktop
function setupDesktopNavPointer() {
  (0, _jquery2.default)(".c-header__navigation-menu-list li").each(function (index) {
    (0, _jquery2.default)(this).attr("index", index);

    (0, _jquery2.default)(this).mouseenter(function () {
      resetPointer();
      elNavigationMenuPointer.addClass("c-header__navigation-menu-pointer--pos-" + (0, _jquery2.default)(this).attr("index"));
    });

    (0, _jquery2.default)(this).mouseleave(function () {
      resetPointer();
      pointerToCurrentPage();
    });
  });

  elNavigationMenuPointer.one("transitionend", function () {
    elNavigationMenuPointer.removeClass(modifierNagivationMenuPointerHidden);
  });
  pointerToCurrentPage();
}

function pointerToCurrentPage() {
  elNavigationMenuPointer.addClass("c-header__navigation-menu-pointer--pos-" + (0, _jquery2.default)("li[aria-current='page'][index]").attr("index"));
}

//resets the pointer in the navigation menu in the header
function resetPointer() {
  for (var i = 0; i < 5; i++) {
    elNavigationMenuPointer.removeClass("c-header__navigation-menu-pointer--pos-" + i);
  }
}

//close the compact header
function compactHeaderClose() {
  elCompactHeader.removeClass("c-header-compact--open");
  elCompactHeader.attr("aria-hidden", true);
  elCompactHeader.find("*").attr("tabindex", "-1");
}

//open the compact header
function compactHeaderOpen() {
  elCompactHeader.addClass("c-header-compact--open").attr("aria-hidden", false).find("button").attr("tabindex", "0"); //make the hamburger and go-to-top button tabbable
}

// Check if the compact header needs to be opened or closed
function compactHeaderCheck() {
  if ((0, _jquery2.default)(document).scrollTop() > headerHeight && !(0, _navigationPanel.isNavigationPanelOpen)() && !(0, _navigationPanel.isDialogOpen)()) {
    compactHeaderOpen();
  } else {
    compactHeaderClose();
  }
}

function setupCompactHeader() {
  headerHeight = (0, _jquery2.default)(".c-header").height();

  (0, _jquery2.default)(window).scroll(compactHeaderCheck);

  elCompactHeaderTopButton.click(function () {
    (0, _jquery2.default)("html, body").animate({ scrollTop: 0 }, "slow");
  });

  compactHeaderCheck();
}

function openNavpanel() {
  (0, _navigationPanel.navigationPanelOpen)();
  compactHeaderClose();
}

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.highContrastCheck = highContrastCheck;
exports.highContrastToggle = highContrastToggle;

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _translate = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Turn high contrast mode on
 *
 * @returns {undefined}
 */
/* global localStorage */

function highContrastOn() {
  // Update body
  (0, _jquery2.default)("html").addClass("t-high-contrast");

  // Set local storage
  localStorage.highContrastMode = "true";

  // Set label(s)
  (0, _jquery2.default)(".js-hc-label").text((0, _translate.trans)("High contrast mode ON"));

  // Set button aria attributes
  (0, _jquery2.default)(".js-hc-toggle").attr("aria-checked", "true");
}

/**
 * Turn high contrast mode off
 *
 * @returns {undefined}
 */
function highContrastOff() {
  // Update body
  (0, _jquery2.default)("html").removeClass("t-high-contrast");

  // Set local storage
  localStorage.highContrastMode = "false";

  // Set label
  (0, _jquery2.default)(".js-hc-label").text((0, _translate.trans)("High contrast mode OFF"));

  // Set button aria attributes
  (0, _jquery2.default)(".js-hc-toggle").attr("aria-checked", "false");
}

/**
 * Check in localStorage if high contrast mode needs to be turned on or off and
 * runs the function to make sure the DOM is up to date.
 *
 * @returns {undefined}
 */
function highContrastCheck() {
  if (localStorage.highContrastMode === "true") {
    highContrastOn();
  } else {
    highContrastOff();
  }
}

/**
 * Check in localStorage if high contrast mode needs to be turned on or off and
 * toggle it accordingly
 *
 * @returns {undefined}
 */
function highContrastToggle() {
  if (localStorage.highContrastMode === "true") {
    highContrastOff();
  } else {
    highContrastOn();
  }
}

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigationPanelOpen = navigationPanelOpen;
exports.isNavigationPanelOpen = isNavigationPanelOpen;
exports.isDialogOpen = isDialogOpen;

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _highContrast = __webpack_require__(35);

var _header = __webpack_require__(34);

var _bodyScrollLock = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Selectors that match all of the dialogs embedded in the navigation panel.
 *
 * @const
 */
/* global document window */
//navigation panel js goes here

var selectorNavigationPanelDialogs = [".c-navigation-panel-dialog-accessibility", ".c-navigation-panel-dialog-accessibility *", ".c-navigation-panel-dialog-languages", ".c-navigation-panel-dialog-languages *"].join(", ");

// Declare pre-stored DOM elements.
//
// While the elements aren't available until the DOM is ready (so they can't be
// selected here), they must be declared here in order to bring them into the
// global namespace of this file, as otherwise they would not be available to
// the rest of the functions which rely on them.

var elOpacityOverlay = void 0;
var elAccessibilityOpenButton = void 0;
var elAccessibilityCloseButton = void 0;
var elHighContrastToggleButton = void 0;
var elLanguagesOpenButton = void 0;
var elLanguagesCloseButton = void 0;
var elAccessibilityDialog = void 0;
var elLanguagesDialog = void 0;
var elNavigationPanel = void 0;
var elNavigationPanelContainer = void 0;
var elHamburgerToggle = void 0;
var elNavigationPanelInteractableAreas = void 0;
//let elBody;

// Modifiers
var modifierAccessibilityDialogOpen = "c-navigation-panel-dialog--open";
var modifierOpacityOverlayOpen = "c-navigation-panel-opacity-overlay--open";
var modifierNavigationPanelOpen = "c-navigation-panel--open";
var navPanelTransitionDuration = 600;

// Defer until launch
(0, _jquery2.default)(function () {
  // Pre-store selectors as DOM elements
  //
  // They were declared before without value, and now a value must be assigned
  // to each of them.
  elOpacityOverlay = (0, _jquery2.default)(".c-navigation-panel-opacity-overlay");
  elAccessibilityOpenButton = (0, _jquery2.default)(".c-navigation-panel__footer-accessibility-link");
  elAccessibilityCloseButton = (0, _jquery2.default)(".c-navigation-panel-dialog__close-button-accessibility");
  elHighContrastToggleButton = (0, _jquery2.default)(".c-navigation-panel-dialog__hc-toggle");
  elLanguagesOpenButton = (0, _jquery2.default)(".c-navigation-panel__footer-languages-button");
  elLanguagesCloseButton = (0, _jquery2.default)(".c-navigation-panel-dialog__close-button-languages");
  elAccessibilityDialog = (0, _jquery2.default)(".c-navigation-panel-dialog-accessibility");
  elLanguagesDialog = (0, _jquery2.default)(".c-navigation-panel-dialog-languages");
  elNavigationPanelContainer = (0, _jquery2.default)(".c-navigation-panel");
  elNavigationPanel = document.querySelector("#c-navigation-panel");
  elHamburgerToggle = (0, _jquery2.default)(".c-header__hamburger");
  elNavigationPanelInteractableAreas = (0, _jquery2.default)(".c-navigation-panel__body, .c-navigation-panel__header");

  // Bind misc
  //

  // Bind clicks on the overlay to close the navigation panel entirely.
  elOpacityOverlay.on("click keypress", navigationPanelClose);

  // Bind accessibility dialog
  //

  //click on the accessibility icon to open the accessiblity dialog
  elAccessibilityOpenButton.on("click", accessibilityDialogOpen);

  //click on the close button of the accessibility dialog
  elAccessibilityCloseButton.on("click", navigationPanelClose);

  //click on the high contrast toggle
  elHighContrastToggleButton.on("click", _highContrast.highContrastToggle);

  // Bind languages dialog
  //

  //click on the language link to open the choose language dialog
  elLanguagesOpenButton.on("click", languagesDialogOpen);

  //click on the close button of the language dialog
  elLanguagesCloseButton.on("click", navigationPanelClose);
});

/**
 * Open the accessibility dialog (in navigation panel)
 *
 * @returns {undefined}
 */
function accessibilityDialogOpen() {
  navigationPanelPartialClose();
  elAccessibilityOpenButton.attr("aria-expanded", "true");
  elAccessibilityDialog.toggleClass(modifierAccessibilityDialogOpen);
}

/**
 * Close the accessibility dialog (in navigation panel)
 *
 * @returns {undefined}
 */
function accessibilityDialogClose() {
  elAccessibilityDialog.removeClass(modifierAccessibilityDialogOpen);

  elOpacityOverlay.removeClass(modifierOpacityOverlayOpen);

  elAccessibilityOpenButton.attr("aria-expanded", "false");
}

/**
 * Open the languages dialog
 *
 * @returns {undefined}
 */
function languagesDialogOpen() {
  navigationPanelPartialClose();

  elLanguagesOpenButton.attr("aria-expanded", "true").attr("aria-hidden", "false").focus().find("a, button").attr("tabindex", "0");
  elLanguagesDialog.addClass(modifierAccessibilityDialogOpen);
}

/**
 * Close the languages dialog
 *
 * @returns {undefined}
 */
function languagesDialogClose() {
  elLanguagesOpenButton.attr("aria-expanded", "false");
  elLanguagesDialog.removeClass(modifierAccessibilityDialogOpen);
}

/**
 * Only close the navigation panel, without closing any dialogs or the opacity
 * overlay.
 *
 * @returns {undefined}
 */
function navigationPanelPartialClose() {
  elNavigationPanelContainer.removeClass(modifierNavigationPanelOpen)
  // Set all buttons to be un-tabblable, except if they're parts of child dialogs
  .find("a, button").not(selectorNavigationPanelDialogs).attr("tabindex", -1);

  //scroll the navigation panel back up
  window.setTimeout(function () {
    return elNavigationPanelContainer.scrollTop(0);
  }, navPanelTransitionDuration);

  (0, _jquery2.default)().attr("aria-hidden", "true");

  // Unbind escape
  (0, _jquery2.default)(document).off("keydown.navigationPanelCloseEsc");
}

/**
 * Open the navigation panel.
 *
 * @returns {undefined}
 */
function navigationPanelOpen() {
  // Set attributes for the navigation panel
  elNavigationPanelContainer.addClass(modifierNavigationPanelOpen).attr("aria-hidden", "false")
  // Set all buttons to be tabbable.
  .find("a, button").attr("tabindex", 0);

  elNavigationPanelInteractableAreas.attr("aria-hidden", "false");

  (0, _jquery2.default)(document).on("keydown.navigationPanelCloseEsc", function (ev) {
    if (ev.key === "Escape") {
      navigationPanelClose();
    }
  });

  // Set attributes for the overlay
  elOpacityOverlay.addClass(modifierOpacityOverlayOpen);

  elHamburgerToggle.attr("aria-expanded", "true").attr("aria-checked", "true");

  //Lock scrolling on the page
  (0, _bodyScrollLock.disableBodyScroll)(elNavigationPanel);
}

/**
 * Close the navigation panel entirely
 *
 * @returns {undefined}
 */
function navigationPanelClose() {
  navigationPanelPartialClose();

  // Remove overlay
  elOpacityOverlay.removeClass(modifierOpacityOverlayOpen);

  languagesDialogClose();
  accessibilityDialogClose();

  elNavigationPanelContainer.attr("aria-hidden", "true");

  elHamburgerToggle.attr("aria-expanded", "false").attr("aria-checked", "false");

  (0, _header.compactHeaderCheck)();

  //Reenable scrolling on the page
  (0, _bodyScrollLock.enableBodyScroll)(elNavigationPanel);
}

function isNavigationPanelOpen() {
  return elNavigationPanelContainer.hasClass(modifierNavigationPanelOpen);
}

function isDialogOpen() {
  return elAccessibilityDialog.hasClass(modifierAccessibilityDialogOpen) || elLanguagesDialog.hasClass(modifierAccessibilityDialogOpen);
}

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = _TRANSLATIONS;

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(65);

__webpack_require__(12);

__webpack_require__(96);

__webpack_require__(34);

__webpack_require__(36);

__webpack_require__(97);

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(66);

__webpack_require__(67);

// Include a polyfill for Object.assign
/* global require */
// Defines base behaviors and style, common to all pages.
__webpack_require__(68).polyfill();
// Include a polyfill for Array.find
__webpack_require__(69).shim();

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
  // Define closure-specific variables
  /** Stores the last potential focus method the user used */
  var lastFocusMethod = void 0;
  /** Stores the last focus target. Cleared on blur */
  var lastTarget = void 0;

  // Detect input methods and store them in `lastFocusMethod`

  // NOTE: this event notation tells jQuery to bind the event to all children
  // of `document` dynamically (i.e. even if they were generated after the DOM
  // onload event)
  (0, _jquery2.default)(document).on("keydown", "*", function () {
    lastFocusMethod = "key";
  });

  (0, _jquery2.default)(document).on("mousedown", "*", function () {
    lastFocusMethod = "mouse";
  });

  (0, _jquery2.default)(document).on("touchstart", "*", function () {
    lastFocusMethod = "touch";
  });

  // Handle focus event
  (0, _jquery2.default)(document).on("focus", "*", function (ev) {
    if (lastTarget) {
      lastTarget.removeAttribute("data-focus-method");
    }
    lastTarget = ev.target;
    ev.target.setAttribute("data-focus-method", lastFocusMethod);
  });

  (0, _jquery2.default)(document).on("blur", "*", function () {
    if (lastTarget) {
      lastTarget.removeAttribute("data-focus-method");
    }
    lastTarget = null;
  });

  (0, _jquery2.default)(document).on("keyup", "div[role=button], div[role=switch]", function (e) {
    if (e.which === 13) {
      // Trigger fake click
      (0, _jquery2.default)(e.target).click();
    }
  });
}); /* global document */

// Manage focus method detection

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HAS_HOVER_CLASS_NAME = "t-has-hover";
var lastTouchTime = 0;

// Set has hover mode on
function enableHover() {
  // filter emulated events coming from touch events
  if (new Date() - lastTouchTime < 500) {
    return;
  }

  if ((0, _jquery2.default)("html").hasClass(HAS_HOVER_CLASS_NAME)) {
    return;
  }

  (0, _jquery2.default)("html").addClass(HAS_HOVER_CLASS_NAME);
}

// Set has hover mode off
function disableHover() {
  if (!(0, _jquery2.default)("html").hasClass(HAS_HOVER_CLASS_NAME)) {
    return;
  }

  (0, _jquery2.default)("html").removeClass(HAS_HOVER_CLASS_NAME);
}

// Save a timestamp of last touch event
function updateLastTouchTime() {
  lastTouchTime = new Date();
}

// Watch for mouse/touch events
function watchForHover() {
  (0, _jquery2.default)("html").get(0).addEventListener("touchstart", updateLastTouchTime, true);

  // On touch events, disable hover effects temporarily
  (0, _jquery2.default)("html").get(0).addEventListener("touchstart", disableHover, true);

  // On mouse move bring back hover effects
  // This is logical in cases where both capabilities are available (e.g touch enables laptops)
  (0, _jquery2.default)("html").get(0).addEventListener("mousemove", enableHover, true);
}

(0, _jquery2.default)(function () {
  watchForHover();
  // Assume hover is available until detected otherwise
  enableHover();
});

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Footer javascript


/***/ }),

/***/ 97:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"breakpointSmall":"767px","breakpointMedium":"1023px"};

/***/ })

},[64]);


// WEBPACK FOOTER //
// js/common.js